import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=b146b182&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./detail.vue?vue&type=style&index=1&id=b146b182&scoped=true&lang=css&"
import style2 from "./detail.vue?vue&type=style&index=2&id=b146b182&lang=scss&scoped=true&"
import style3 from "./detail.vue?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b146b182",
  null
  
)

export default component.exports